import React, { useEffect, useState } from 'react'
import AssessmentDetails from '../../../common/AssessmentDetails';
import SkeletonTicketList from '../../../../loaders/SkeletonTicketList';
import { useParams } from 'react-router-dom';
import { GetMarkingAssessmentDetails } from '../../../../services/CourseService';
import AssessmentStudentList from '../../../common/AssessmentStudentList';
import AssessmentQuizTestMarking from './AssessmentQuizTestMarking';

function AssessmentMarking() {
  const {id, subId } = useParams();
  const searchParams = new URLSearchParams(window.location.search)
  const questionId = searchParams.get('questionId');
  const [loading, setloading] = useState(false);
  const [assessmentDetails, setAssessmentDetails] = useState({});

  const fetchAssessmentDetails = () => {
    setloading(true)

    GetMarkingAssessmentDetails(subId, id)
      .then((response) => {
        setAssessmentDetails(response?.data);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setloading(false)
      })
  }

  useEffect(() => {
    fetchAssessmentDetails();
  }, []);


  return (
    <>
    {
      questionId  ?
            <AssessmentQuizTestMarking assessmentHeader={assessmentDetails?.assessmentDetail} />
          :
            <>
              {loading ? <SkeletonTicketList /> : <AssessmentDetails assessmentHeader={assessmentDetails?.assessmentDetail} />}
              <AssessmentStudentList assessmentDetails={assessmentDetails?.assessmentDetail} fetchAssessmentDetails={fetchAssessmentDetails} />
            </>
      
    
    }
    </>
  )
}

export default AssessmentMarking
